import { Subscription } from 'rxjs';
import { loginErrorComponent } from './../core-content-manager/modals/login-error/login-error.component';
import { Router } from '@angular/router';
import { GetService } from './../Services/get.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  currentYear:any;
  signInError= false;
  logInForm:FormGroup;
  toggleImg= "assets/images/hidepass.png";
  toggleImgClick = false;
  logInSubscriptions = new Subscription();
  logoLink =environment.websiteUrl;
  constructor(private fb:FormBuilder, private getser:GetService, private rout:Router,private spinner:NgxSpinnerService,private dialog:MatDialog) { }


  ngOnInit(): void {
    this.currentYear = (new Date()).getFullYear();
    this.logInForm = this.fb.group({
      username: new FormControl('', [Validators.required,Validators.email]),
      password: new FormControl('', Validators.required)
    })

  }
  //signin Method

  get f() {
    return this.logInForm.controls;
  }
  openDialog(){
    this.dialog.open(loginErrorComponent)
  }
  signIn()
  {
    this.spinner.show();
    if(this.logInForm.invalid){
      return;
    }


    let data = {
      email: this.f.username.value,
      password: this.f.password.value,
    };

    this.logInSubscriptions = this.getser.login(data).subscribe(
      (data) => {
        this.rout.navigate(['/dashboard']);
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.openDialog();
        this.signInError = true;
        // console.log(error);

        // this.error(error);
      }
    );


  }
  TogglePassword()
  {
    const id = document.getElementById('pass');

    this.toggleImgClick = !this.toggleImgClick;
    if(this.toggleImgClick == true){
      this.toggleImg = "assets/images/showpass.png";
      id.setAttribute('type', 'text');
    }else{
      this.toggleImg = "assets/images/hidepass.png";
      id.setAttribute('type', 'password');

    }
      }
ngOnDestroy(): void {

  this.logInSubscriptions.unsubscribe();
}

}

